export default __webpack_public_path__ + "static/LeituraTwo-Bold-26caec42def5e63b54e0a7b7eca2ca99.woff";